// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"SearchBefore_searchIcon__1VeKk"};